<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-1">
    <i class="fal fa-user"></i>
    <ng-container i18n *ngIf="!isEdit">Add Guest</ng-container>
    <ng-container i18n *ngIf="isEdit">Edit Guest</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body bg-none p-0">
  <form [formGroup]="guestForm">
    <div class="container-box p-3">
      <div class="row">
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <i class="cs-icon cs-icon-user" matPrefix></i>
            <input type="text" matInput required placeholder="Name" i18n-placeholder formControlName="name" />
            <mat-error *ngIf="guestForm.get('name').touched && guestForm.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div
          (click)="isEdit && editEmail()"
          [class.click-disabled]="1 | isReadonlyRole"
          class="col-sm-6 position-relative"
        >
          <i
            matTooltip="Edit the primary email or add a secondary email to this guest."
            i18n-matTooltip
            class="cs-icon cs-icon-pencil btn-edit"
            *ngIf="isEdit"
          ></i>
          <mat-form-field2 class="mat-block">
            <mat-label i18n> Email </mat-label>
            <i class="cs-icon cs-icon-envelope" matPrefix></i>
            <input
              type="email"
              matInput
              required
              placeholder="Email"
              i18n-placeholder
              formControlName="email"
              [readonly]="isEdit"
              [disabled]="isEdit"
            />
            <mat-error *ngIf="guestForm.get('email').touched && guestForm.get('email').hasError('required')">
              <ng-container i18n>Email is required</ng-container>
            </mat-error>
            <mat-error i18n *ngIf="guestForm.get('email').touched && guestForm.get('email').hasError('email')">
              Email must have valid format
            </mat-error>
          </mat-form-field2>
        </div>
        <div
          (click)="isEdit && editPhone()"
          [class.click-disabled]="1 | isReadonlyRole"
          class="col-sm-6 position-relative"
        >
          <i
            matTooltip="Edit the primary phone number or add a secondary phone number to this guest."
            i18n-matTooltip
            class="cs-icon cs-icon-pencil btn-edit"
            *ngIf="isEdit"
          ></i>
          <app-phone-number-input
            [ctrl]="guestForm.get('phone')"
            [showPrefix]="true"
            *ngIf="!isEdit"
          ></app-phone-number-input>
          <mat-form-field2 class="mat-block" *ngIf="isEdit">
            <i class="cs-icon cs-icon-phone" matPrefix></i>
            <input
              type="text"
              formControlName="phone"
              matInput
              placeholder="Phone Number"
              i18n-placeholder
              readonly
              disabled
            />
            <mat-error *ngIf="guestForm.get('phone').touched && guestForm.get('phone').hasError('required')">
              <ng-container i18n>Phone is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <app-phone-number-input
            [ctrl]="guestForm.get('whatsapp_phone')"
            prefixIcon="fab fa-whatsapp text-lg text-whatsapp"
            [showPrefix]="true"
            i18n-hint
            hint="WhatsApp message is free!"
            i18n-placeholder
            placeholder="WhatsApp Number"
          ></app-phone-number-input>
        </div>
      </div>
    </div>
    <div class="container-box p-3 mt-3">
      <div class="row" formGroupName="address">
        <div class="col-sm-12">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="address"
              matInput
              appGooglePlaces
              (onAddressChange)="onPlaceChange($event)"
              placeholder="Address"
              i18n-placeholder
            />
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="city" matInput placeholder="City" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="state" matInput placeholder="State" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <app-country-select
            [nameCtrl]="addressForm.get('country')"
            [codeCtrl]="addressForm.get('country_code')"
          ></app-country-select>
        </div>
        <div class="col-sm-6">
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="postal_code" matInput placeholder="Postal Code" i18n-placeholder />
          </mat-form-field2>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(guestForm)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
